import Cookies from "js-cookie";

export const setAuthenticationCookie = async data => {
  const {
    accessToken,
    refreshToken,
    user: { guid }
  } = data;

  let encodedString = btoa(`${guid}#${refreshToken}#${accessToken}`);
  await Cookies.set("RE_BU_CR", encodedString, { expires: 7 });
  return null;
};

export const getAuthenticationCookie = async () => {
  let cookie = await Cookies.get("RE_BU_CR");

  if (!cookie) return false;

  const decodedString = atob(cookie);
  let [guid, refreshToken, accessToken] = decodedString.split("#");

  return { guid, refreshToken, accessToken };
};
